// Region keys aligned with api.service.js getRegion() switch cases
export const REGIONS = {
  us: 'US',
  eu: 'EU',
  aus: 'Australia',
  singapore: 'Singapore',
  uae: 'UAE',
  internal: 'Internal',
  localhost: 'Localhost',
  eastus2: 'East US 2',
  australiaeast: 'Australia',
  canadacentral: 'Canada Central',
  westeurope: 'West Europe'
}

// Persist selected region for Agentnoon users
const LS_KEY = 'agentnoon_region'

export const getPersistedRegion = () => {
  try {
    const v = localStorage.getItem(LS_KEY)
    return v || null
  } catch {
    return null
  }
}

export const setPersistedRegion = (region) => {
  try {
    if (!region) localStorage.removeItem(LS_KEY)
    else localStorage.setItem(LS_KEY, region)
  } catch {
    // ignore storage errors
  }
}

export const deletePersistedRegion = () => {
  try {
    localStorage.removeItem(LS_KEY)
  } catch {
    // ignore storage errors
  }
}

// Provide a label for a given region key
export const getRegionLabel = (regionKey) => {
  const host = window.location.hostname
  if (host.includes('np.dayforce') || host.includes('np.mydayforce')) {
    return `Dayforce NP (${REGIONS[regionKey] || regionKey})`
  }
  if (host.includes('pre.dayforce') || host.includes('pre.mydayforce')) {
    return `Dayforce Pre (${REGIONS[regionKey] || regionKey})`
  }
  if (host.includes('dayforcehcm.com') || host.includes('dayforce.com')) {
    return `Dayforce (${REGIONS[regionKey] || regionKey})`
  }
  return REGIONS[regionKey] || regionKey
}
